import { PolluxGridConfig } from "../../../../../components/common/pollux-grid-config/pollux-grid-config";

export const projectGridColumns: PolluxGridConfig[] = [
  {
    field: "checkbox",
    type: "checkbox",
    width: 40
  },
  {
    title: 'projectstd.name',
    field: "Name",
    type: "special",
    width: 200
  }, {
    title: 'projectstd.projectPhaseValuationId',
    field: "ProjectPhaseValuationIdDescription",
    width: 200
  },
  {
    title: 'projectstd.internalConfidentiality',
    field: "internalConfidentialityDescription",
    width: 200
  },
  {
    title: 'projectstd.companyType',
    field: "CompanyType",
    width: 200
  },
  {
    title: 'projectstd.clientManual',
    field: "ClientManual",
    width: 200
  },
  {
    title: 'projectstd.valuationPurpose',
    field: "valuationPurposeDescription",
    width: 200
  },
  {
    title: 'projectstd.specialAgreement',
    field: "SpecialAgreementDescription",
    width: 200
  },
  {
    title: 'projectstd.projectStdNumberOfProperty',
    field: "ProjectStdNumberOfProperty",
    width: 200
  },
  {
    title: 'projectstd.valuationVolume',
    field: "ValuationVolume",
    type: "currency",
    width: 200
  },
  {
    title: 'projectstd.acquiredVia',
    field: "acquiredViaDescription",
    width: 200
  },
  {
    title: 'projectstd.reportScope',
    field: "ReportScopeDescription",
    width: 200
  },
  {
    title: 'projectstd.oid',
    field: "Oid",
    type: "special",
    width: 200
  },
  {
    title: 'projectstd.recordStatusId',
    field: "RecordStatusIdDescription",
    width: 200
  },
  {
    title: 'projectstd.currency',
    field: "currencyDescription",
    width: 200
  },
  {
    title: 'projectstd.unitOfLength',
    field: "unitOfLengthDescription",
    width: 200
  },
  {
    title: 'projectstd.createdDate',
    field: "CreatedDate",
    type: "date",
    width: 200
  },
  {
    title: 'projectstd.ownerUserId',
    field: "OwnerUserIdDescription",
    width: 200
  },
  {
    title: 'projectstd.ownerBuId',
    field: "OwnerBuIdDescription",
    width: 200
  },
  {
    title: 'projectstd.historyLastEntryDate',
    field: "HistoryLastEntryDate",
    type: "date",
    width: 200
  },
  {
    title: 'projectstd.modifiedByUserId',
    field: "ModifiedByUserIdDescription",
    width: 200
  },
  {
    title: 'projectstd.modifiedBuId',
    field: "ModifiedBuIdDescription",
    width: 200
  },
  {
    title: 'projectstd.importFormat',
    field: "ImportConfigurationIdDecription",
    width: 200
  },
  {
    title: 'projectstd.totalMarketValue',
    field: "TotalMarketValue",
    type: "currency",
    width: 200
  },
  {
    title: 'projectstd.portfolio',
    field: "Portfolio",
    width: 200
  },
  {
    title: 'projectstd.client',
    field: "Client",
    width: 200
  }
];
